import { render, staticRenderFns } from "./Slides.vue?vue&type=template&id=33092ca7&scoped=true&"
import script from "./Slides.vue?vue&type=script&lang=js&"
export * from "./Slides.vue?vue&type=script&lang=js&"
import style0 from "./Slides.vue?vue&type=style&index=0&id=33092ca7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33092ca7",
  null
  
)

export default component.exports